module.exports = __webpack_public_path__ + "static/swarm_of_bats-867ff0ba0bbd059a0b9019c64be61d70.jpeg";